import React, { useState } from 'react';
import {
    Button,
    Image,
    Text,
    Checkbox,
    AlertDialog,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogBody,
    AlertDialogHeader,
    AlertDialogOverlay,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';


const Szabadsag = ({ message,isOpen, onClose }) => {
    return (
        <AlertDialog isOpen={isOpen} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold" textAlign="center">
                        Kedves Vásárlóink!
                    </AlertDialogHeader>
                    <AlertDialogBody textAlign='justify'>
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button onClick={onClose}>Bezár</Button>
                        <Button colorScheme="red" onClick={onClose} ml={3}>
                            Értem
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};


export default Szabadsag;
